import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';
import { qk } from '../keys';
import type { ExportKind, ExportLogRow, ExportResult, ExportSettings } from '../types';

/** Адресите за трите документа и дали пощата на сървъра е настроена. */
export function useExportSettings() {
  return useQuery({
    queryKey: qk.exports.settings(),
    queryFn: () => api.get<ExportSettings>('/document-exports/settings'),
    staleTime: 60_000,
  });
}

export function useUpdateExportSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: Pick<ExportSettings, 'enabled' | 'recipients'>) =>
      api.put<ExportSettings>('/document-exports/settings', input),
    onSuccess: (data) => queryClient.setQueryData(qk.exports.settings(), data),
  });
}

/** Дневникът — на цялата фирма или на една заявка. */
export function useExportLog(orderId?: string) {
  return useQuery({
    queryKey: qk.exports.log(orderId),
    queryFn: () => api.get<ExportLogRow[]>('/document-exports', { ...(orderId ? { orderId } : {}), limit: orderId ? 20 : 100 }),
    staleTime: 15_000,
  });
}

/** „Изпрати пак" — документите на заявката сега, на настроените адреси. */
export function useSendOrderDocuments(orderId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (kinds?: ExportKind[]) =>
      api.post<ExportResult[]>(`/document-exports/orders/${orderId}`, kinds ? { kinds } : {}),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: qk.exports.all }),
  });
}
